import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend'; // <= new

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: 'fr',
    fallbackLng: 'fr',
    defaultNS: 'translation',
    backend: { // <= new
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    }
  });

export default i18n;